import { createContext, useContext, type ReactNode } from 'react';

const MeasurementPassContext = createContext(false);

/**
 * Marks `DocumentRender`'s off-screen height pass. Editors must not mount here:
 * the same field would render a second "Insert a dynamic value" control, and
 * `TextareaAutosize` inside a `height: 0` overlay feeds pagination a moving height.
 */
export function MeasurementPassScope({ children }: { children: ReactNode }) {
  return <MeasurementPassContext.Provider value={true}>{children}</MeasurementPassContext.Provider>;
}

export function useIsMeasurementPass(): boolean {
  return useContext(MeasurementPassContext);
}
